/**
 * Determine whether a file is of the right size or not.
 *
 * @constant
 * @type {Function}
 * @param {File} file
 * @param {object} [options]
 * @param {number} [options.maxImageFileSizeMb]
 * @param {number} [options.minImageFileSizeMb]
 * @returns {boolean} whether the file is the correct size or not
 */
export const isCorrectSize = (file, { maxImageFileSizeMb = 500, minImageFileSizeMb = 0 } = {}) => {
    if ((file === null || file === void 0 ? void 0 : file.size) === undefined) {
        return false;
    }
    // Convert to MB by dividing by 1024^2
    const size = (file === null || file === void 0 ? void 0 : file.size) / (1024 * 1024);
    return minImageFileSizeMb <= size && size <= maxImageFileSizeMb;
};
